<script setup lang="ts">
/**
 * Shared chat application chrome: optional sidebar + main column.
 * Domain logic (channels, agents, WS) stays in the app.
 */
defineProps<{
  /** Soft canvas background behind the main pane (default true). */
  canvas?: boolean;
}>();
</script>

<template>
  <div class="nx-chat-shell" :class="{ canvas: canvas !== false }">
    <aside v-if="$slots.sidebar" class="nx-chat-shell__sidebar">
      <slot name="sidebar" />
    </aside>
    <div class="nx-chat-shell__main">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.nx-chat-shell {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: var(--nxt-surface-bg);
  color: var(--nxt-fg);
}
.nx-chat-shell.canvas {
  background: var(--nxt-bg-app);
}
.nx-chat-shell__sidebar {
  flex: 0 0 auto;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.nx-chat-shell__main {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--nxt-surface-bg);
}
</style>
